import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { AccountService } from '../../shared/services/account.service';
import { AppService } from "../../shared/services/app.service";
import { Router, ActivatedRoute } from '@angular/router';
import { LanguageService } from '../../shared/services/language.service';
import { DOCUMENT } from '@angular/common';
import {DomSanitizer,SafeResourceUrl,} from '@angular/platform-browser';

declare var $: any; import {isBrowser} from '../../shared/thirdparty/isBrowser'
declare var Swal:any;

@Component({
  selector: 'app-formation',
  templateUrl: './formation.component.html',
  styleUrls: ['./formation.component.scss']
})
export class FormationComponent implements OnInit {

  constructor(
      public accountService : AccountService,
      public appService : AppService,
      public router : Router,
      public language : LanguageService,
      public sanitizer:DomSanitizer,
      @Inject(DOCUMENT) public document: Document
  ) { }


public certifications = [
    {
        src : "assets/certifications/logo-nf-service",
        width : "60px",
        name : " NF Service",
    },
    {
        src : "assets/certifications/logo-datadock",
        width : "40px",
        name : "Datadock",
    },
    {
        src : "assets/certifications/logo-cnefop",
        width : "40px",
        name : "CNEFOP",
    },
    {
        src : "assets/certifications/logo-opcalim",
        width : "50px",
        name : "OPCALIM",
    },
    {
        src : "assets/certifications/logo-cqp",
        width : "80px",
        name : "CQP",
    },
    {
        src : "assets/certifications/logo-odpc",
        width : "70px",
        name : "ODPC",
    },
    {
        src : "assets/certifications/logo-evalim",
        width : "80px",
        name : "Evalim",
    },
    {
        src : "assets/certifications/logo-qualiopi",
        width : "90px",
        name : "Qualiopi",
    },
    {
        src : "assets/certifications/logo_carsat",
        width : "120px",
        name : "Carsat",
    },
    {
        src : "assets/certifications/logo-dreet",
        width : "110px",
        name : "DREETS",
    },
    {
        src : "assets/certifications/cybervadis",
        width : "110px",
        name : "Cybervadis",
        isSVG: true,
    }
]

public collapse:boolean = true;


  ngOnInit() {


  }


  freeAccess(){
      this.router.navigate(this.language.navigateAccordingToLang(['/demo']))
  }

}
